<template>
	<div class="card-chart-icons" ref="iconWrapper">
		<div
			v-for="(factor, indexFac) in icons"
			:key="indexFac"
			class="icon-container"
			:style="{ width: iconWidth}"
		>
			<img
				:src="factor.image"
				:alt="factor.image"
			>
		</div>
	</div>
</template>

<script>
export default {
	name: 'card-chart-icons',
	props: {
		icons: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		iconWidth() {
			const containerWidth = this.$refs.iconWrapper.offsetWidth || 0;
			return `${containerWidth / this.icons.length}px`;
		},
	},
};
</script>

<style lang='scss' scoped>
.card-chart-icons {
	display: flex;
	margin-top: -20px;
	.icon-container {
		text-align: center;
		img {
			max-width: 100%;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/diagnosis/card-chart-icons.vue